<div class="login-container">

  <div class="login-card-wrapper">
    <div class="right-side-box flex items-center">
      <div class="login-card">
        <div class="card-header">
          <!-- Guideline: the PSA BDP logo sits at the top of the login box, in
               black. Logomark Full is used here because this is the first (and
               only) placement on the screen. -->
          <div class="logo-section">
            <img class="brand-logo" src="/layout/images/psabdp-logomark-black.png" alt="PSA BDP" />
            <!-- <h1 class="app-name">IDP</h1> -->
            
            <div class="welcome-section">
            <h2 class="welcome-title">{{ step === 'email' ? 'Welcome' : 'Enter Your Password' }}</h2>
            <p class="welcome-subtitle">
              {{ step === 'email' ? 'Log in to IDP to continue.' : 'Enter your password for IDP to continue.' }}
            </p>
          </div>
          </div>
        </div>

        <div class="card-body">
          

          <!-- Error Message Display -->
          <div *ngIf="errorMessage" class="error-message">
            <i class="pi pi-exclamation-triangle"></i>
            <span>{{ errorMessage }}</span>
          </div>

          <form [formGroup]="loginForm" (ngSubmit)="onContinue()" class="signin-form" #loginFormDirective="ngForm">

            <!-- ===================== STEP 1: EMAIL ===================== -->
            <div class="input-group" *ngIf="step === 'email'">
              <p-floatlabel variant="on">
                <input pInputText id="username" formControlName="username" class="modern-input"
                  autocomplete="username" [disabled]="isLoading" (input)="usernameControl.markAsTouched()" />
                <label for="username">Email address*</label>
              </p-floatlabel>
              <small class="field-error" *ngIf="usernameControl.touched && usernameControl.invalid">
                {{ usernameControl.hasError('required') ? 'Email address is required' : 'Enter a valid email address' }}
              </small>
            </div>

            <!-- ===================== STEP 2: PASSWORD ===================== -->
            <ng-container *ngIf="step === 'password'">
              <!-- Chosen identity, with a way back to step 1 -->
              <div class="identity-row">
                <span class="identity-email" [title]="usernameControl.value">{{ usernameControl.value }}</span>
                <a href="javascript:void(0)" (click)="onEditEmail()" class="edit-link">Edit</a>
              </div>

              <div class="input-group">
                <p-floatlabel variant="on">
                  <p-password inputId="password" formControlName="password" styleClass="modern-password"
                    inputStyleClass="password-input" [toggleMask]="true" [feedback]="false"
                    [disabled]="isLoading" autocomplete="current-password">
                  </p-password>
                  <label for="password">Password*</label>
                </p-floatlabel>
                <small class="field-error" *ngIf="passwordControl.touched && passwordControl.invalid">
                  Password is required
                </small>
              </div>

              <div class="form-extras">
                <a href="javascript:void(0)" (click)="onForgotPassword()" class="forgot-password">
                  Forgot Password?
                </a>
              </div>
            </ng-container>

            <p-button type="submit" label="Continue" iconPos="right"
              [icon]="isLoading ? 'fa-solid fa-spinner fa-spin' : ''" styleClass="primary-button"
              [disabled]="isLoading" size="large">
            </p-button>
          </form>
        </div>
      </div>
    </div>
  </div>

</div>

<!-- FORGOT PASSWORD MODAL -->
<!-- =================== FORGOT PASSWORD DIALOG =================== -->
<p-dialog [(visible)]="forgotVisible" [modal]="true" [closable]="false" [blockScroll]="true"
  [style]="{ width: '420px' }" contentStyleClass="forgot-dialog-body" [autoZIndex]="true">

  <ng-template #headless>

    <!-- TOAST INSIDE MODAL (TOP CENTER) -->
    <p-toast key="forgotToast" position="top-center" class="forgot-toast"></p-toast>

    <div class="forgot-wrapper">
      <!-- <button pButton icon="pi pi-times" class="p-button-text p-button-rounded" (click)="closeResetDialog()">
      </button> -->

      <!-- ===================== EMAIL SCREEN ===================== -->
      <ng-container *ngIf="!otpMode && !resetPasswordMode">

        <h2 class="forgot-title">Forgot Your Password?</h2>

        <p class="forgot-subtitle">
          Enter the email address associated with your account
        </p>

        <input pInputText [(ngModel)]="forgotEmail" name="forgotEmail" placeholder="Email Address" type="email"
          class="forgot-input" />

        <button [disabled]="!forgotEmail || !isValidEmail(forgotEmail)" pButton label="Send OTP" (click)="sendOTP()"
          class="primary-button" type="button"></button>

        <button pButton label="Back to Login" class="forgot-login-btn" type="reset"
          (click)="forgotVisible = false; forgotEmail=''"></button>

      </ng-container>

      <!-- ===================== OTP SCREEN ===================== -->
      <ng-container *ngIf="otpMode && !resetPasswordMode">

        <h2 class="forgot-title">Enter Verification Code</h2>

        <p class="forgot-subtitle">
          We have sent a 6-digit verification code to your email
        </p>

        <!-- INPUT OTP -->
        <p-inputOtp [(ngModel)]="otp" name="otpCode" [length]="6" [integerOnly]="true" styleClass="mx-auto mb-4">
        </p-inputOtp>

        <button [disabled]="otp.length !== 6" pButton label="Verify OTP" class="primary-button"
          (click)="verifyOTP()"></button>

        <p class="resend-text" *ngIf="resendTimer > 0">
          You can resend OTP in {{ resendTimer }} seconds
        </p>

        <p class="resend-text" *ngIf="resendTimer === 0">
          Didn't receive the code? <a href="javascript:void(0)" (click)="sendOTP()" class="resend-link">Resend OTP</a>
        </p>

        <button pButton label="Back" type="reset" class="forgot-login-btn" (click)="otpMode = false; otp=''"></button>

      </ng-container>
      <!-- ===================== RESET PASSWORD SCREEN ===================== -->
      <ng-container *ngIf="resetPasswordMode" [formGroup]="resetPasswordForm">

        <div class="flex justify-between items-center mb-3">
          <h2 class="forgot-title">Reset Your Password</h2>
          <button pButton icon="pi pi-times" class="p-button-text p-button-rounded" (click)="closeResetDialog()">
          </button>
        </div>

        <!-- NEW PASSWORD -->
        <p-password formControlName="newPassword" placeholder="New Password" styleClass="modern-password mb-4"
          inputStyleClass="forgot-input" [toggleMask]="true" [feedback]="false">
        </p-password>

        <!-- VALIDATION MESSAGES -->
        <div class="error-text" *ngIf="resetPasswordForm.get('newPassword')?.touched">
          <div *ngIf="resetPasswordForm.get('newPassword')?.errors?.['uppercase']">• One uppercase letter required</div>
          <div *ngIf="resetPasswordForm.get('newPassword')?.errors?.['lowercase']">• One lowercase letter required</div>
          <div *ngIf="resetPasswordForm.get('newPassword')?.errors?.['number']">• One number required</div>
          <div *ngIf="resetPasswordForm.get('newPassword')?.errors?.['special']">• One special character required</div>
          <div *ngIf="resetPasswordForm.get('newPassword')?.errors?.['length']">• Minimum 8 characters</div>
        </div>

        <!-- CONFIRM PASSWORD -->
        <p-password formControlName="confirmPassword" placeholder="Confirm Password" styleClass="modern-password mb-2"
          inputStyleClass="forgot-input" [toggleMask]="true" [feedback]="false">
        </p-password>

        <div class="error-text"
          *ngIf="resetPasswordForm.errors?.['passwordMismatch'] && resetPasswordForm.get('confirmPassword')?.touched">
          • Passwords do not match
        </div>

        <!-- RESET BUTTON -->
        <button pButton label="Reset Password" class="primary-button mb-4" [disabled]="resetPasswordForm.invalid"
          (click)="resetPASSWORD()">
        </button>

      </ng-container>


    </div>
  </ng-template>

</p-dialog>